// theme/theme.js
import { createDarkTheme, createLightTheme } from "@fluentui/react-components";

const lekOilBrand = {
  10: "#001A3D",
  20: "#00235C",
  30: "#002D7A",
  40: "#003799",
  50: "#0041B8",
  60: "#0052CC",
  70: "#0066FF",
  80: "#1A75FF",
  90: "#3385FF",
  100: "#4D95FF",
  110: "#66A3FF",
  120: "#80B2FF",
  130: "#99C2FF",
  140: "#B3D1FF",
  150: "#CCE0FF",
  160: "#E6F0FF",
};

export const lekOilLightTheme = createLightTheme(lekOilBrand);
export const lekOilDarkTheme = createDarkTheme(lekOilBrand);

// Custom token overrides
export const customTokens = {
  colorBrandBackground: "#0052CC",
  colorBrandBackgroundHover: "#0041B8",
  colorBrandForeground1: "#0052CC",
};

// Card gradient presets
export const cardGradients = {
  blue: "linear-gradient(135deg, #0052CC 0%, #0041B8 100%)",
  green: "linear-gradient(135deg, #107C10 0%, #0B5C0B 100%)",
  orange: "linear-gradient(135deg, #D83B01 0%, #A52801 100%)",
  purple: "linear-gradient(135deg, #5C2D91 0%, #40208C 100%)",
  teal: "linear-gradient(135deg, #008272 0%, #005F53 100%)",
  gold: "linear-gradient(135deg, #986F0B 0%, #7A5800 100%)",
};
